import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

const AdminOnly = ({ children }) => {
  const role = useSelector((state) => state.auth?.login?.user?.role || state.auth?.login?.user?.roles);
  return role === 'Admin' ? children : <Redirect to="/admin" />;
};
AdminOnly.propTypes = { children: PropTypes.node.isRequired };
export default AdminOnly;
